<template>
	<div class="pui-form">
		<v-form class="mb-4 pb-4" ref="form" v-model="valid" lazy-validation v-if="modelLoaded">
			<v-layout wrap class="pui-form-layout">
				<v-flex xs12 md12 lg6>
					<pui-field-set :title="this.$t('form.puivariable.title')">
						<pui-text-field
							:label="this.$t('form.puivariable.variable')"
							v-model="model.variable"
							maxlength="100"
							toplabel
							required
							noeditable
							disabled
						></pui-text-field>
						<pui-text-area
							:label="this.$t('form.puivariable.value')"
							v-model="model.value"
							toplabel
							required
							noeditable
							:disabled="formDisabled"
						></pui-text-area>
						<pui-text-area
							:label="this.$t('form.puivariable.description')"
							v-model="model.description"
							maxlength="500"
							toplabel
							noeditable
							:disabled="formDisabled"
						></pui-text-area>
					</pui-field-set>
				</v-flex>
			</v-layout>
			<pui-form-footer>
				<pui-form-footer-btns
					:formDisabled="formDisabled"
					:saveDisabled="saving"
					:saveAndUpdate="saveAndUpdate"
					:save="save"
					:back="back"
				></pui-form-footer-btns>
			</pui-form-footer>
		</v-form>
		<pui-form-loading v-else></pui-form-loading>
	</div>
</template>

<script>
import PuiFormMethodsMixin from '../../../../../pui9-mixins/PuiFormMethodsMixin';

export default {
	name: 'PuiVariableForm',
	mixins: [PuiFormMethodsMixin],
	data() {
		return {
			modelName: 'puivariable'
		};
	}
};
</script>
